import { useParams } from 'react-router-dom';

import { api } from '../../api';
import { Campaign } from '../../types';

export const useGetCampaignByUrl = (): Campaign | undefined => {
  const { id } = useParams();

  const campaignsList = api.useGetCampaignsQuery();

  const campaign = campaignsList.data?.find((campaign) => campaign.id === Number(id));

  return campaign;
};
